import Typography from "@mui/material/Typography";
import type { FC } from "react";

import type { IMarket } from "~/types/event";

import { getStatusCellLines } from "./getStatusCellLines";
import * as Styled from "./StatusCell.styles";

interface IStatusCellProps {
  market: IMarket;
}

export const StatusCell: FC<IStatusCellProps> = ({ market }) => (
  <Styled.Lines>
    {getStatusCellLines(market).map((line) => (
      <Typography key={line} variant="caption">
        {line}
      </Typography>
    ))}
  </Styled.Lines>
);
